import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";

const AuthLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [secureTextEntry, setSecureTextEntry] = useState(true);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      alert("Kindly provide a valid email and password.");
      return;
    }

    setLoading(true);
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      navigate("/Menu", { state: { userId: user.uid } });
    } catch (error) {
      let errorMessage = "An error occurred during login.";
      if (error.code === "auth/user-not-found") {
        errorMessage = "Kindly ensure your account is activated.";
      } else if (error.code === "auth/wrong-password") {
        errorMessage = "Incorrect password.";
      } else if (error.code === "auth/invalid-email") {
        errorMessage = "Invalid email address.";
      }
      alert(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <img src="/cosmologo.png" alt="Logo" style={styles.image} />
      <h2 style={styles.title}>WELCOME</h2>
      <p style={styles.subtitle}>Login with your credentials below</p>
      {loading && <div style={styles.loadingText}>Logging in...</div>}
      <form onSubmit={handleLogin} style={styles.form}>
      <div style={styles.passwordContainer}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
        />
        </div>
        <div style={styles.passwordContainer}>
          <input
            type={secureTextEntry ? "password" : "text"}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />
          <button
            type="button"
            onClick={() => setSecureTextEntry(!secureTextEntry)}
            style={styles.toggleButton}
          >
            {secureTextEntry ? "👁️" : "🙈"}
          </button>
        </div>
        <button type="submit" style={styles.loginButton}>
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
      <p style={styles.activateText} onClick={() => navigate("/Login")}>
        Need to activate your account? Click Here!
      </p>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f4f6f8",
    padding: "20px",
    textAlign: "center",
  },
  image: {
    width: "120px",
    height: "120px",
    marginBottom: "20px",
    borderRadius: "60px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#333",
  },
  subtitle: {
    fontSize: "16px",
    color: "#666",
    marginBottom: "30px",
  },
  loadingText: {
    fontSize: "16px",
    color: "#007bff",
    marginBottom: "10px",
  },
  form: {
    width: "100%",
    maxWidth: "400px",
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
  },
  input: {
    width: "100%",
    padding: "15px",
    marginBottom: "10px",
    borderRadius: "10px",
    border: "1px solid #ccc",
    fontSize: "16px",
    outline: "none",
  },
  passwordContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  toggleButton: {
    position: "absolute",
    right: "15px",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "18px",
    color: "#666",
  },
  loginButton: {
    backgroundColor: "#013a64",
    padding: "15px",
    borderRadius: "10px",
    color: "#fff",
    fontSize: "18px",
    fontWeight: "bold",
    cursor: "pointer",
    border: "none",
    width: "100%",
    marginTop: "10px",
  },
  activateText: {
    marginTop: "20px",
    color: "#007bff",
    cursor: "pointer",
    fontSize: "14px",
  },
};

export default AuthLogin;